import React, { memo } from "react";
import { Modal } from "@mui/material";
import { makeStyles } from "@material-ui/styles";
import iconClose from "../../../assets/images/icon-close-how-to-play.svg";
// import bg from "../../../assets/images/bg.webp";
// import bg_mobile from "../../../assets/images/bg_mobile.webp";
import useScreen, { SCREEN_LIST } from "../../../hook/useScreen";
import useDeviceDetect from "../../../hook/useDeviceDetect";
import { useTheme } from "../../../hook/useThemes";
import ContentModal from "./ContentModal";
import Logo from "../../../assets/images/logo-upordown_demo.png";

type PropsContentHowToPlay = {
  open: boolean;
  onClose: () => void;
};


function ContentHowToPlay({ onClose, open }: PropsContentHowToPlay) {
  const heightScreen = useScreen();
  const classes = useStyles();
  const { isMobile } = useDeviceDetect();
  const { lang, operatorId,settingImage  } = useTheme();

  // ${isMobile && "style-modal-custom"}
  const isMinHeight = heightScreen <= SCREEN_LIST.screenHeight2 && isMobile;
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={`${classes.modal} `}
      open={open}
      onClose={onClose}
      closeAfterTransition
    >
      <div
        className={`${classes["wrapper-content-modal"]}`}
        onClick={(e) => e?.stopPropagation()}
      >
        <div className={`${classes["wrap-content-modal"]}`}>
          <div
            className={`${classes["title-modal"]}
          ${isMinHeight && classes["title-modal-min"]}`}
          >
            <div className="title-top">
              <img src={operatorId ===2? settingImage.logo : settingImage.logo ||  Logo} alt="logo" className="logo-how-to-play" />
              <p className="title">{lang?.how_to_play || "How to Play ?"}</p>
            </div>
            <p className="description">
              {lang?.how_to_play_description_1min ||
                "Every 60 seconds, the Bitcoin price is locked, and a new round begins."}
            </p>
          </div>
          <ContentModal />
          <div className={`${classes["wrapper-button-close"]}`}>
            <button className={classes["button-close"]} onClick={onClose}>
              <img
                src={iconClose}
                alt="icon_close"
                className={classes["icon-close"]}
              />
              {lang?.close || "Close"}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
export default memo(ContentHowToPlay);

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "auto",
    position: "fixed",
    top: "0px !important",
    bottom: "0px !important",
    width: "100%",
    height: "100%",

    "& .MuiBackdrop-root": {
      top: "0px !important",
      bottom: "0px !important",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%",
    },
  },

  "wrapper-content-modal": {
    width: "1200px",
    height: "675px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
    zIndex: 100,
    background: "#141C29",

    // "&::before": {
    //   content: '" "',
    //   position: "absolute",
    //   top: "0px",
    //   left: "0px",
    //   width: "100%",
    //   height: "100%",
    //   background: `url(${bg})`,
    //   backgroundPosition: "100% 100%",
    //   backgroundSize: "100% 100%",
    //   backgroundRepeat: "no-repeat",
    //   zIndex: 101,
    //   opacity: "30%",
    // },

    "@media (max-width: 1199px)": {
      width: "960px",
      height: "540px",
    },

    "@media (max-width: 959px)": {
      width: "100%",
      height: "100%",
      justifyContent: "start",

      // "&::before": {
      //   content: '" "',
      //   position: "absolute",
      //   top: "0px",
      //   left: "0px",
      //   width: "100%",
      //   height: "100%",
      //   background: `url(${bg_mobile})`,
      //   backgroundPosition: "100% 100%",
      //   backgroundSize: "100% 100%",
      //   backgroundRepeat: "no-repeat",
      //   zIndex: 101,
      //   opacity: 1,
      // },
    },
  },

  "wrap-content-modal": {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    padding: "100px 130px 62px 130px",
    gap: "52px",
    zIndex: 101,

    "@media (max-width: 1199px)": {
      padding: "32px 50px",
      gap: "36px",
    },

    "@media (max-width: 959px)": {
      width: "375px",
      height: "100%",
      justifyContent: "start",
      padding: "32px 24px",

      "@media (max-height: 700px)": {
        gap: "24px",
      },

      "@media (max-height: 600px)": {
        padding: "24px",
        gap: "18px",
      },
    },
  },

  "title-modal": {
    display: "flex",
    flexDirection: "column",
    gap: "24px",

    "& .title-top": {
      display: "flex",
      gap: "40px",

      "& .logo-how-to-play": {
        width: "58px",
        height: "26px",
      },

      "& .title": {
        fontSize: "24px",
        fontWeight: 700,
        lineHeight: "25px",
        color: "#F1F1F1",
      },

      "@media (max-width: 959px)": {
        gap: "28px",
      },
    },

    "& .description": {
      color: "#F7931A",
      fontSize: "20px",
      fontWeight: 400,
    },

    "@media (max-width: 1199px)": {
      marginBottom: "12px",
    },

    "@media (max-width: 959px)": {
      marginBottom: "24px",

      "@media (max-height: 600px)": {
        gap: "18px",
        marginBottom: "0px",
      },
    },
  },

  "wrapper-button-close": {
    width: "100%",
    display: "flex",
    justifyContent: "center",

    "@media (max-width: 959px)": {
      margin: "auto 0px",
    },
  },

  "button-close": {
    display: "flex",
    alignItems: "center",
    padding: "8px 9px",
    background: "transparent",
    border: "1px solid #525965",
    borderRadius: "6px",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#ffffff1f",
    },
  },

  "icon-close": {
    marginRight: "8px",
  },
}));
